<template>
  <div class="remove">

      <span class="input-group-addon title" v-if="title">{{title}}</span>
      <div :class="['input-group-btn', 'dropdown', 'd-block', !formEdit && editMode? 'formEdit' : '' ,calWidth != 0 ? ('width-' + calWidth) : '']" ref="dropdown">
        <button type="button" class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" :disabled="!formEdit && editMode" :style="{width: !isAuto && calWidth != 0 ? (calWidth+ 'px') : 'auto'}"><div style="text-align:left;display:inline-block;width: calc(100% - 20px);">{{showCheckbox ? checkedDisplayNames : selectedValue}}</div></button>
        <div :class="['dropdown-menu',  'dropdown-menu-scale', inline]"  >
          <ul ref="list" style="max-height: 200px; overflow-y: auto;">
            <li v-for="(item, index) in datasource" :key="index" @mousedown="itemClick(item)" @click="itemClickHanlder()">
              <a v-if="item[itemDisabledField] != null" class="dropdown-item" :class="[item[valueName] == value && isSelectedIcon ? 'selected' : '']" disabled="">
                <label class="md-check" style="margin-right:0" v-if="showCheckbox">
                  <input type="checkbox" v-model="item.checked" @mousedown="itemCheck(item)">
                  <i class="blue"></i>
                </label>
                {{item[displayName]}}</a>

              <a v-if="item[itemDisabledField] == null" class="dropdown-item" :class="[item[valueName] == value && isSelectedIcon ? 'selected' : '']" >
                <label class="md-check" style="margin-right:0" v-if="showCheckbox">
                  <input type="checkbox" v-model="item.checked" @mousedown="itemCheck(item)">
                  <i class="blue"></i>
                </label>
                {{item[displayName]}}</a>
            </li>
          </ul>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  //props: ['value', 'datasource', 'valueName', 'displayName', 'isSelectionFirstData'],
  props: {
    value:{

    },
    inline: {
      type: String,
      default: function() {
        return null;
      }
    },
    width: {
      type: Number,
      default: function() {
        return null;
      }
    },
    title: {
      type: String,
      default: function() {
        return "";
      }
    },
    datasource: {
      type: Array,
      default: function() {
        return [{}];
      }
    },
    showCheckbox: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isDropup: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isMultiple: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    valueName: {
      type: String,
      default: function() {
        return "value";
      }
    },
    displayName: {
      type: String,
      default: function() {
        return "name";
      }
    },
    isSelectionFirstData: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    editMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isEdit: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isFieldMode: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    itemDisabledField: {
      type: String,
      default: function() {
        return "";
      }
    },
    isAuto: {
      type: Boolean,
      default: function(){
        return false;
      }
    },
    isSelectedIcon: {
      type: Boolean,
      default: function(){
        return false;
      }
    }
  },
  computed: {
    calWidth() {
        var result = 0;
        result = this.autoWidth;
        if(this.width)
          result = this.width;
        return result;
    },
    checkedDisplayNames() {
      var that = this;
      if(this.checkedItems)
        return this.checkedItems.map(x=>x[that.displayName]).join(", ");
    }
  },
  data() {
    return {
      checkedItems: '',
      selectedItem: null,
      selectedValue: null,
      selectedIndex: null,
      formEdit: false,
      tempData: null,
      autoWidth: 0,

    };
  },
  mounted() {
    this.$nextTick(function () {
 	 // remove unwanted element all other is work jQuery required
	  	$('.remove').contents().unwrap();

  	})
    this.initComponent(true);
  },
  watch: {
    value: function(newVal, oldVal){
      if(newVal != oldVal){
        this.initComponent();
        this.$forceUpdate();
      }
    },
    /*
    datasource : function(newVal, oldVal){
      if(newVal != oldVal){
        this.initComponent(true);
      }
    },
    */

    selectedItem: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.datasource.forEach(
          function(item, index) {
            if (item[this.valueName] == newVal[this.valueName]) {

              this.selectedIndex = index;
              this.selectedValue = this.datasource[this.selectedIndex][this.displayName];
              this.$emit("changeValue", {
                evnetName: "changeValue",
                data: this.datasource[this.selectedIndex]
              });
              this.$emit(
                "input",
                this.datasource[this.selectedIndex][this.valueName]
              );
            }
          }.bind(this)
        );
      }
    }
  },
  methods: {
    initComponent(isFirst) {
      this.formEdit = this.isEdit;
      var that = this;

      if(this.autoWidth == 0 || isFirst){
        setTimeout(()=>{
          that.autoWidth =  $(that.$refs.list.parentElement).outerWidth() + 21.83;
        },100)
      }
      if (this.value != null) {
        this.datasource.forEach(
          function(item, index) {
            if(this.itemDisabledField != ""){

              item.disabled = item[this.itemDisabledField];
            }
            if (item[this.valueName] == this.value) {
              this.selectedItem = item;
              return;
            }

            /*
            if(this.autoWidth == 0)
              this.autoWidth =  this.$refs.list.clientWidth
            //가장긴 필드 찾기
            //this.$nextTick(function () {
              /*
              this.$refs.lenField.textContent = item[this.displayName];
              if(this.autoWidth < this.$refs.lenField.clientWidth)
                this.autoWidth  = this.$refs.lenField.clientWidth;
              console.log(item[this.displayName] + this.$refs.lenField.clientWidth)
              */

            //})
          }.bind(this)
        );
      }
      setTimeout(function() {
        if (this.selectedItem == null && this.isSelectionFirstData) {
          this.selectedItem = this.datasource[0];
        }
        this.tempData = Object.assign({}, this.selectedItem);
        if(this.isMultiple){
          this.changeCheckedItems();
        }
      }.bind(this), 300)
    },
    itemClick(item) {

      if(item[this.itemDisabledField]!=undefined) {
        return ;
      }

      this.selectedItem = item;
      setTimeout(
        function() {
          this.formEdit = true;
          this.$emit("close");
          this.$emit("input", item[this.valueName]);
          if(this.isMultiple){
            $(this.$refs.dropdown).addClass('show');
          }
          this.selectedIndex = _.findIndex(this.datasource, x => item[this.valueName] == x[this.valueName])
          this.selectedValue = this.datasource[this.selectedIndex][this.displayName];
        }.bind(this)
      );

      if(this.isMultiple){
        if($(event.target).hasClass('blue'))
          return;
        item.checked = !item.checked;
        this.changeCheckedItems();
      }
    },
    changeCheckedItems(item){
      var that = this;
      var result = [];
      this.datasource.forEach((item)=>{
        if(item.checked)
          result.push(item)
      })
      result.join(",")
      //this.checkedDisplayNames = result.map(x=>x[that.displayName]).join(", ");
      this.checkedItems = result;
      this.$emit('checkBoxChange', result);
    },
    itemClickHanlder(){
      if(this.showCheckbox){
        event.stopImmediatePropagation();
        event.stopPropagation();
      }
    },
    itemCheck(item) {
      var that = this;
      if(this.isMultiple)
        $(this.$refs.dropdown).addClass('show');
      item.checked = !item.checked;
      setTimeout(()=>{
        that.changeCheckedItems();
      },300)
    },
    open() {
      this.$emit("open");
    },
    modeChange(){

      this.formEdit = !this.formEdit;
    },
    confirmInput(event) {
      this.formEdit = false;
      this.$parent.$emit("confirmInput", {childrenCall: true});
      this.$emit("confirmInput");

    },
    cancelInput(event) {

      this.formEdit = false;
      this.selectedItem = Object.assign({}, this.tempData);
      this.$parent.$emit("cancelInput");
    },
  }
};
</script>

<style>
</style>
